<template lang="pug">
.queue-avatar
  img(v-if="!check" :src="avatar")
  icon-check(v-if="check")
  
  
</template>
<script>
import IconCheck from '@/components/wedgits/IconCheck'
export default {
  name: 'QueueAvatar',
  components: { IconCheck },
  props: {
    check: {},
    avatar: {},
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.queue-avatar
  width: pxToRem(50)
  height: pxToRem(50)
  overflow: hidden
  border-radius: pxToRem(25)
  border: 2px white solid
  display: flex
  align-items: center
  justify-content: center
  margin-left: pxToRem(10)
  img
    width: 100%
    height: 100%
    object-fit: contain
</style>
